<!-- <div class="view-container"> -->
<!-- <div class="brands"> -->
<mat-card>
  <mat-card-content>
    <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
      fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
      <label>Your Brands</label>
      <button mat-flat-button type="button" color="accent" (click)="onOpenAddBrands()" matTooltip="Add Range">
        <mat-icon>add</mat-icon>Add Brands
      </button>
    </div>
    <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
      <mat-card-content>
        <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
          <mat-form-field>
            <mat-label>Filter by name</mat-label>
            <input matInput type="text" [formControl]="nameFilterControl" name="brand Name">
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <div>
      <div class="header-row" fxHide.lt-md>
        <div>Brand</div>
        <div>Brand Logo</div>
        <div>Quality Level</div>
        <div>Edit</div>
      </div>
      <ng-container *ngFor="let brandRow of filteredBrands | async">
        <div class="brand-row" [ngClass]="{'editing': brandRow.editMode}" gdColumns.lt-md="1fr 4fr" gdColumns.lt-sm="1fr">
          <!-- Display Brand-->
          <ng-container *ngIf="!brandRow.editMode">
            <small fxHide.gt-sm>Name</small>
            <span>{{brandRow.brand.name}}</span>
            <small fxHide.gt-sm>Logo</small>
            <img class="product-brand-logo" alt="Brand Logo"
              [src]="brandRow.brand.brandLogoUrl || '/assets/images/no-image-icon.svg'">
            <small fxHide.gt-sm>Quality Level</small>
            <span>{{ QualityLevel[brandRow.brand.qualityLevel] || "Unset" }}</span>
            <small fxHide.gt-sm></small>
            <div class="actions">
              <button mat-icon-button (click)="onEditBrand(brandRow)" matTooltip="Edit Brand">
                <mat-icon>edit</mat-icon></button>
            </div>
          </ng-container>

          <!-- Edit Brand -->
          <ng-container *ngIf="brandRow.editMode">
            <mat-form-field>
              <mat-label>Brand Name</mat-label>
              <input matInput [formControl]="brandRow.form.controls.name">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Brand Logo Url</mat-label>
              <input matInput [formControl]="brandRow.form.controls.brandLogoUrl">
              <mat-checkbox matSuffix [matTooltip]="'Only show brand logo in callouts'"
                [formControl]="brandRow.form.controls.showBrandLogoOnly"></mat-checkbox>
            </mat-form-field>
            <div>
              <mat-button-toggle-group [formControl]="brandRow.form.controls.qualityLevel">
                <mat-button-toggle [value]="null">None</mat-button-toggle>
                <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                  <mat-button-toggle [value]="quality.value">{{quality.key}}</mat-button-toggle>
                </ng-container>
              </mat-button-toggle-group>
            </div>
            <div class="actions">
              <button mat-icon-button (click)="onDeleteBrand(brandRow)"
              matTooltip="Delete Brand"><mat-icon color="warn">delete</mat-icon></button>
              <button mat-icon-button (click)="brandRow.editMode = false"
                matTooltip="Cancel Editing"><mat-icon>cancel</mat-icon></button>
              <button mat-icon-button (click)="onSaveChanges(brandRow)"
                matTooltip="Save Changes"><mat-icon>save</mat-icon></button>
            </div>
          </ng-container>

        </div>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>